const initialState = {
  type16: null,
  countEI: 0,
  countSN: 0,
  countTF: 0,
  countJP: 0,
  type: null,
  outline: null,
  element1: null,
  element2: null,
  element3: null,
  element4: null,
  element5: null,
  element6: null,
  element7: null,
  element8: null,
  relationsComment: null,
  lifeComment: null,
  jobComment: null,
  loveComment: null,
  relation: [],
  datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_PERSONALITY_SET') {
    let newState = {
      type16: action.payload.type16,
      countEI: action.payload.count.EI,
      countSN: action.payload.count.SN,
      countTF: action.payload.count.TF,
      countJP: action.payload.count.JP,
      type: action.payload.type.type,
      outline: action.payload.type.type_outline,
      element1: action.payload.type.type_element1,
      element2: action.payload.type.type_element2,
      element3: action.payload.type.type_element3,
      element4: action.payload.type.type_element4,
      element5: action.payload.type.type_element5,
      element6: action.payload.type.type_element6,
      element7: action.payload.type.type_element7,
      element8: action.payload.type.type_element8,
      relationsComment: action.payload.type.type_relations,
      lifeComment: action.payload.type.type_life,
      jobComment: action.payload.type.type_job,
      loveComment: action.payload.type.type_love,
      relation: action.payload.relation,
      datetime: (new Date()),
    };
		return newState;
	}
	if (action.type === 'MY_PERSONALITY_RESET') {
    let newState = {
      type16: null,
      countEI: 0,
      countSN: 0,
      countTF: 0,
      countJP: 0,
      type: null,
      outline: null,
      element1: null,
      element2: null,
      element3: null,
      element4: null,
      element5: null,
      element6: null,
      element7: null,
      element8: null,
      relationsComment: null,
      lifeComment: null,
      jobComment: null,
      loveComment: null,
      relation: [],
      datetime: (new Date()),
    };
		return newState;
	}
	else {
		return state;
	}
}
